var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.bgBottom),expression:"bgBottom"}],staticClass:"bg-bottom"}),_vm._v(" "),_c('div',{staticClass:"main"},[_vm._v("技术支持：江苏新视云科技股份有限公司")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa2d1a7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheFooter.vue
// module id = null
// module chunks = 